import { toast } from 'sonner';

import { useModal } from '@/hooks';
import { toastError } from '@/utils';

import { useCreateTypeMutation } from '../../../../features/slice/products/type/type-api-slice';
import { TypeForm } from '../type-form.component';

export const CreateType = () => {
    const [createType, { isLoading }] = useCreateTypeMutation();
    const { closeModal } = useModal();

    const handleSubmit = async (values: { name: string }) => {
        try {
            await createType(values).unwrap();
            toast.success('Type has been created');
            closeModal();
        } catch (error) {
            toastError(
                error,
                'CreateType: handleSubmit -> Failed to create type.',
            );
        }
    };

    return (
        <TypeForm
            initialValues={{ name: '' }}
            onSubmit={handleSubmit as any}
            isLoading={isLoading}
            title={'Create Type'}
        />
    );
};
